import presetsReducer from './presets';
import propertiesReducer from './properties';
import testingReducer from './testing';
import { combineReducers } from 'redux';

const defaultReducer = combineReducers({
  presets: presetsReducer,
  properties: propertiesReducer,
  testing: testingReducer,
});

export default defaultReducer;
